import { isEmpty } from 'lodash';
import React from 'react';
import styled from 'styled-components';
import { type PromoCodeValidationProps } from '../../context';
import PromoCodeCheckIcon from '../assets/promoCodeCheckIcon.svg';
import PromoCodeCloseIcon from '../assets/promoCodeCloseIcon.svg';
import PromoCodeErrorIcon from '../assets/promoCodeErrorIcon.svg';

export const StyeldPromoCodeRemoveIcon = styled(PromoCodeCloseIcon)`
    display: flex;
    align-items: center;
    margin-left: 10px;
`;

export const PromoCodeDescriptionLabel = styled.label`
    margin-top: 10px;
    font-weight: bold;
    font-size: 16px !important;
    display: flex;
    align-items: center;
`;

export const PromoCodeLabel = styled(PromoCodeDescriptionLabel)`
    display: flex;
    font-weight: bold;
    text-transform: uppercase;
    font-size: 16px !important;
`;

export const PromoCodeDescription = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const PromoCodeDescriptionSpan = styled.span<{ error?: boolean; success?: boolean }>`
    margin-top: 16px;
    display: flex;
    font-size: 16px !important;
    line-height: 1;
    word-break: break-all;
    ${props => props.error && `color: rgb(204, 25, 34);`}
    ${props => props.success && `color: rgb(25, 126, 16);`}
`;
export const StyledPromoCodeCheckIcon = styled(PromoCodeCheckIcon)`
    margin-right: 10px;
    margin-top: -7px;
    height: 25px;
    width: 25px;
    min-width: 25px;
`;

export const StyledPromoCodeErrorIcon = styled(PromoCodeErrorIcon)`
    margin-right: 10px;
    margin-top: -5px;
    height: 25px;
    width: 25px;
    min-width: 25px;
`;

const PromoCodeValidation = (props: PromoCodeValidationProps) => {
    const { removePromoCode, promoCode, promoCodeError, promoCodeAmount } = props;

    return (
        <>
            {promoCode && promoCode.promoType.__typename === 'DiscountPromoType' && (
                <>
                    <PromoCodeDescription>
                        <PromoCodeLabel>
                            <span>{promoCode.promoCode}</span>
                            <StyeldPromoCodeRemoveIcon onClick={removePromoCode} />
                        </PromoCodeLabel>
                        <PromoCodeDescriptionLabel>{promoCodeAmount}</PromoCodeDescriptionLabel>
                    </PromoCodeDescription>

                    <PromoCodeDescriptionSpan success>
                        <StyledPromoCodeCheckIcon />
                        {promoCode.promoType.description}
                    </PromoCodeDescriptionSpan>
                </>
            )}
            {promoCode && promoCode.promoType.__typename === 'GiftPromoType' && (
                <PromoCodeDescriptionSpan success>
                    <StyledPromoCodeCheckIcon />
                    {promoCode.promoType.description}
                </PromoCodeDescriptionSpan>
            )}
            {isEmpty(promoCode) && promoCodeError && (
                <PromoCodeDescriptionSpan error>
                    <StyledPromoCodeErrorIcon />
                    {promoCodeError}
                </PromoCodeDescriptionSpan>
            )}
        </>
    );
};
export default PromoCodeValidation;
